import { render, staticRenderFns } from "./PackagePromo.vue?vue&type=template&id=7b334df8&scoped=true"
import script from "./PackagePromo.vue?vue&type=script&lang=ts"
export * from "./PackagePromo.vue?vue&type=script&lang=ts"
import style0 from "./PackagePromo.vue?vue&type=style&index=0&id=7b334df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b334df8",
  null
  
)

export default component.exports